enum AdministrationPageNamesEnum {
    Organisations = 'organisations',
    Projects = 'projects',
    Users = 'users',
    Cities = 'cities',
    Replacement = 'replacement',
}

export default AdministrationPageNamesEnum;
